const state = {
    isActive: false,
    activeLotId: '',
}

const getters = {
    getBidModalStatus: (state) => (lotId) => {
        return state.isActive && state.activeLotId === lotId
    },
    getActiveBidModalStatus: (state) => {
        return state.isActive
    },
    getActiveBidModalLotId: (state) => {
        return state.activeLotId
    }
 }

const mutations = {
    setBidModalStatus: (state, newStatus) => {
        state.isActive = newStatus.status
        state.activeLotId = newStatus.lotId
    }
}

const actions = {
    changeBidModalStatus: ({ commit }, newStatus) => {
        commit('setBidModalStatus', newStatus)
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/bidModal.js